// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"74076c3d","787":"cde3c4c1","865":"46f3c373"}[chunkId] + ".chunk.js";
};